module.exports = __webpack_public_path__ + "img/egypt.b866e47c.webp";